export const FundsSummary = ({ fundsData }) => {
  const currencySymbols = {
    USD: "$",
    CAD: "C$",
    INR: "₹",
    EUR: "€",
    GBP: "£",
  };

  const symbol = currencySymbols[fundsData.currency] || "";

  // helper function to format amounts
  const formatAmount = (amount) => {
    if (!amount) return "0.00";
    return parseFloat(amount).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const totalAmount = `${symbol}${formatAmount(fundsData.total_amount)} ${
    fundsData.currency
  }`;
  const totalAmountInr = `₹${formatAmount(fundsData.total_amount_inr)} INR`;

  return (
    <div className="relative bg-purple-100 px-12 py-3 mb-4 inline-block text-center rounded-lg shadow-sm">
      {/* left triangle */}
      <span
        className="absolute left-0 top-1/2 -translate-y-1/2 
          w-0 h-0 border-t-[30px] border-t-transparent 
          border-b-[30px] border-b-transparent 
          border-l-[30px] border-l-white"
      ></span>

      {/* right triangle */}
      <span
        className="absolute right-0 top-1/2 -translate-y-1/2 
          w-0 h-0 border-t-[30px] border-t-transparent 
          border-b-[30px] border-b-transparent 
          border-r-[30px] border-r-white"
      ></span>

      <p className="font-altis font-bold text-[18px] leading-[100%] tracking-[0] text-center text-gray-800 whitespace-nowrap">
        Total funds required:&nbsp;
        <span className="font-semibold">{totalAmount}</span>
        &nbsp;converted to&nbsp;
        <span className="font-semibold">{totalAmountInr}</span>
      </p>
    </div>
  );
};
